import React, { useContext } from "react";
import { Link } from "react-router-dom";
import UserBasicInfoContext from "../../../components/Context/UserBasicInfoContext";
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";
import HomeComplete from "./HomeComplete";






const Home = () => {

    const userBasicInfo = useContext(UserBasicInfoContext);
    const selectedCompanyInfo = useContext(UserBasicInfoQRContext);


    return (
        <div className="custom-container w-full float-left px-8 pt-5 pb-20 flex font-montserrat">

            {/* Left Section */}
            <div className="custom-container-left custom-scroll-auto float-left w-4/5 pb-10 pr-3 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>
                <HomeComplete />
            </div>

            {/* Right Section */}
            <div className="custom-container-right float-right w-1/5 pl-2 custom-scroll-auto pb-10 flex flex-col items-center">
                <div className="box-full w-full  bg-[#F5F5F5] text-[#222222] text-justify rounded-[5px] px-5 py-3" title="Personal Name">
                    <p className="border-b-2 font-semibold">Name</p>
                    <p className="font-medium text-base pt-1 mt-1">{userBasicInfo?.name}</p>
                </div>

                <div className="box-full w-full mt-4 bg-[#F5F5F5] text-[#222222] text-justify rounded-[5px] px-5 py-3" title="Phone Number">
                    <p className="border-b-2 font-semibold">Mobile Number</p>
                    <p className="font-medium text-base pt-1 mt-1">{userBasicInfo?.mobile_no}</p>
                </div>

                <div className="box-full w-full mt-4 bg-[#F5F5F5] text-[#222222] text-justify rounded-[5px] px-5 py-3" title="Email Address">
                    <p className="border-b-2 font-semibold">Email Address</p>
                    <p className="font-medium text-base pt-1 mt-1">{userBasicInfo?.email}</p>
                </div>

                <div className="box-full w-full mt-4 bg-[#F5F5F5] text-[#222222] text-justify rounded-[5px] px-5 py-3" title="Current Shop">
                    <p className="border-b-2 font-semibold">
                        Current Shop
                        <Link to="/dashboard/select-company" className="float-right text-sm font-bold text-green-500">
                            switch
                        </Link>
                    </p>
                    {(selectedCompanyInfo) &&
                        <div className="font-medium text-base pt-2 mt-1 text-left flex">
                            {(selectedCompanyInfo.logo) &&
                                <img src={selectedCompanyInfo.logo} alt={selectedCompanyInfo.name} title="logo" className="max-w-[50px] max-h-[50px] mt-1 float-left object-contain" />
                            }

                            <div className="pl-3 float-left grid">
                                <span className="text-sm"> {selectedCompanyInfo.name}</span>
                                <span className="text-xs"> {selectedCompanyInfo.mobile_no} </span>
                                <span className="text-xs"> {selectedCompanyInfo.email} </span>
                            </div>
                        </div>
                    }
                </div>


                <div className="box-full w-full mt-4 bg-[#F5F5F5] text-[#222222] text-justify rounded-[5px] px-5 py-3">
                    <p className="border-b-2 font-semibold">
                        KAM Information
                    </p>
                    
                    <div className="font-medium text-base pt-2 mt-1 text-left flex">
                        <div className="pl-0 float-left grid">
                            <span className="text-sm pb-0.5">{selectedCompanyInfo?.kam?.name}</span>
                            <span className="text-sm">{selectedCompanyInfo?.kam?.mobile_no}</span>
                            <Link to={`mailto:`+selectedCompanyInfo?.kam?.email} className="text-sm">{selectedCompanyInfo?.kam?.email}</Link>
                        </div>
                    </div>
                    
                </div>

            </div>
        </div>

    );
}



export default Home;